import React from 'react';
import { styled } from 'styled-components';

const MapContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 2rem 0;
  iframe {
    border: 0px;
    width: 600px;
    height: 420px;
  }
`;

export const Map = () => {
  return (
    <MapContainer>
      <iframe
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2798.5328826386194!2d9.176916812650074!3d45.459068370953354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c1557c06ae4b%3A0x80ddee19a7a573ec!2sVia%20Gian%20Giacomo%20Mora%2C%2020%2C%2020123%20Milano%20MI%2C%20Italia!5e0!3m2!1sno!2sno!4v1756068023160!5m2!1sno!2sno'
        allowfullscreen='false'
        loading='lazy'
        referrerPolicy='no-referrer-when-downgrade'
      ></iframe>
    </MapContainer>
  );
};
